import { Component, OnInit } from '@angular/core';
import { VproService } from "src/app/service/vpro/vpro.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import moment from 'moment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-patient-organisation',
  templateUrl: './patient-organisation.component.html',
  styleUrls: ['./patient-organisation.component.css']
})
export class PatientOrganisationComponent implements OnInit {
  email_id: string;
  dob: string;
  contact_no: number;
  org: any;
  patientForm: UntypedFormGroup;
  pat_name: string;
  enableform: any;
  validOTP: boolean = false;
  wrongOTP: boolean = false;
  pid: number;
  org_OTP: any;
  constructor(
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private modalService: NgbModal
  ) { }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  ngOnInit(): void {
    this.loadPatient();
    this.patientForm = this._formBuilder.group(
      {
        otp: ["", Validators.required],
      })


  }
  loadPatient() {
    this.spinner.show();
    this.service.getPatientById(localStorage.getItem("uid"), '?fields=members').subscribe(res => {
      if (res) {
        // console.log("loadPatient", res)
        this.email_id = res.email_id
        console.log(moment(res.dob).format('YYYY-MM-DD'))
        this.dob = moment(res.dob).format('YYYY-MM-DD')
        this.contact_no = res.contact_no
        this.pat_name = res.first_name + res.last_name
        this.pid = res.pid
        this.getOrganisation();

      }

    }, err => {
      this.spinner.hide();
    });
  }

  getOrganisation() {
    let data = {
      contact_no: this.contact_no,
      dob: this.dob,
    };
    this.service
      .PatientOrganisation(data)
      .subscribe(
        (res) => {
          // console.log("res,res", res)
          this.org = res;
          console.log("res,res", this.org.length)

          this.getConnectedOrg();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }
  SendOTP(pid_contact, content, org_code) {
    if (pid_contact) {
      let contact = this.contact_no;
      // console.log("org_code", org_code)


      // console.log("pid_contact", pid_contact)
      this.spinner.show();
      // console.log("iiiiiiiiiiiiiii", index)
      this.modalService.open(content, { centered: true }).result.then(

      );
      // this.enableform[index] = true
      this.service
        .requestOrgOTP({ contact_no: contact, dob: this.dob, org_code: org_code })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.spinner.hide();

          },
          (error) => {
            console.log(error);
            this.spinner.hide();
            this.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  validateOTP() {
    // console.log("this.patientForm.value.otp", this.patientForm.value.otp)
    // if (this.validOTP) return;
    if (this.patientForm.value.otp) {
      this.spinner.show();
      this.service
        .validateOrgOTP({
          contact_no: this.contact_no,
          otp: this.patientForm.value.otp,
          pid: this.pid
        })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            window.location.reload();
            this.otpValidated();
          },
          (err) => {
            // console.log(err);
            this.spinner.hide();
            let message =
              err && err.error && err.error.message && err.error.message.message
                ? err.error.message.message
                : "Something wrong. Couldn't delete appointment.";
            this.showToast("error", message);
            if (err.error.message.message) {
              this.wrongOTP = true;
              return;
            }
          }
        );
    }
  }
  otpValidated() {
    this.patientForm.controls["otp"].disable();
  }
  getConnectedOrg() {
    let data = {
      contact_no: this.contact_no,
      online_pid: this.pid
    };
    this.spinner.show();
    this.service
      .PatientOrganisationOTP(data)
      .subscribe(
        (res) => {

          this.org_OTP = res;
          // console.log("org_OTP", res)


          this.org.forEach(x => {
            x[0].Checked = this.org_OTP.some(y => y.org_code === x[0].org_code);
            console.log(x.Checked)
          });
          // console.log("this.org", this.org)
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }
}
